<div fxFlex fxLayout="row" fxLayout.xs="row" fxLayoutAlign="space-between end">
  <div>© 2025 Synaptica S.A.</div>
  <div>948161449 / Lima - Perú</div>
</div>


